import {UpmPlantsHierarchyNode, UpmPlantsHierarchyType} from '../types'

export const collectPlantIds = (node: UpmPlantsHierarchyNode): string[] => {
  if (node.type === UpmPlantsHierarchyType.Plant) {
    return [node.hierarchyId]
  }
  return node.children.flatMap(collectPlantIds)
}
